import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import './plugins/bootstrap-vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueMobileDetection from 'vue-mobile-detection'

Vue.config.productionTip = false

Vue.use(VueMobileDetection)
Vue.use(Vuelidate)

Vue.use(VueGtag, {
  config: { id: "UA-1234567-1" },
  includes: [{ id: 'AW-857852491' }]
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
